import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsMlpTextComponent extends Component {
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1'>
          <form.fieldset @titleKey='elements' as |fieldset|>
            <fieldset.field @property='headline' />
            <fieldset.field @property='text' @type='text-editor' />
          </form.fieldset>
        </div>
      </div>
    </Form>
  </template>
}
